<template>
  <div class="job-detail-container">
    <open-app @openLinkApp="openLinkApp" v-show="!isWxMini && !isAlipayClient && !isUCClient && !isQuaReClient && !loading" :small-btn="false" />
    <w-nav-bar v-if="!loading && !isWxMini" :nav_title="jobInformation && jobInformation.job_post" class="navbar" :style="{top: (isHarmony || isWxMini || isAlipayClient || isUCClient || isQuaReClient) ? '0px' : '56px'}" @mobileLeftBtn="toBack"
                 :icon="isWxMini && (needShare || isJobMiniProgram) ? '' : 'iconchevron-left'">
<!--      <div slot="rightContent" class="right-content" @click="changeLike(jobInfo)">-->
<!--        <span class="iconfont" :class="jobInfo && jobInfo.is_like ? 'iconstar' : 'iconstar1'"></span>-->
<!--      </div>-->
    </w-nav-bar>
    <div v-if="notJob" class="not-job">
      <img src="https://files.wondercv.com/404_moblie.png" alt="">
    </div>
    <div v-else-if="!loading && !notJob" :class="{'detail-wrapper': !notJob}" :style="[iosOrAndroidStyle, {'paddingTop': isWxMini ? '0' : ((isAlipayClient || isUCClient || isQuaReClient) ? '44px' : '94px')}, { }]">
      <div class="job-top">
        <div class="detail-header flex-column">
          <div class="job-post flex-between">
            <span class="job-title">
              {{ jobInformation.job_post }}
            </span>
            <span class="job-salary">{{(jobInformation.annual_month_salary && jobInformation.annual_month_salary > 12) ? `${jobInformation.salary} · ${jobInformation.annual_month_salary}薪` : `${jobInformation.salary}`}}</span>
          </div>
          <div class="job-basic-info flex-start">
            <div class="job-city">
              <i class="iconfont iconxianjuchengshi"></i>
              <span>{{ jobInformation.city || '全国' }}</span>
            </div>
            <div class="degree">
              <i class="iconfont iconxueli1"></i>
              <span>{{ jobInformation.degree || '学历不限' }}</span>
            </div>

            <template v-if="jobInformation.job_nature === '全职'">
              <div class="experience">
                <i class="iconfont iconqiuzhiyixiang"></i>
                <span>{{ !jobInformation.experience || jobInformation.experience === '不限' ? '经验不限' : (jobInformation.experience === '1年以下' ? '1年以内' : jobInformation.experience) }}</span>
              </div>
            </template>

            <template v-if="jobInformation.job_nature === '实习'">
              <div class="intern" v-if="jobInformation.intern_frequency && jobInformation.intern_duration">
                <i class="iconfont iconshijian"></i>
                <span>{{ `${jobInformation.intern_frequency}天/周·${jobInformation.intern_duration}` }}</span>
              </div>
            </template>

            <template v-if="jobInformation.job_nature === '校招'">
              <div class="intern">
                <i class="iconfont iconshijian"></i>
                <span>{{ jobInformation.graduate_times | formatGraduationYear }}</span>
              </div>
            </template>

          </div>
          <div class="job-source">发布于 {{ moment(jobInformation.publish_time).format('M月D日') }}</div>
        </div>
        <div class="hr-box" @click="handleClickTohr">
          <div class="hr-info">
            <img :src="hr.hr_avatar" width="42" height="42"/>
            <div>
              <p class="flex"><span class="hr-name">{{ boss_hr ? boss_hr.hr_name : hr.hr_name  }}</span><span class="hr-dot"></span><span class="hr-state">{{jobInformation.origin_source === "boss直聘" ? '职位来自BOSS直聘' : '刚刚活跃'}}</span></p>
              <p class="company-name">{{ boss_company ? boss_company.company_name : companyInformation.company_nick_name}} · {{ boss_hr ? boss_hr.company_position : hr.company_position}}</p>
            </div>
          </div>
          <div class="interview" v-if="jobInformation.origin_source !== 'boss直聘' ">
            <span>该职位支持极速面试，投递成功率更高！</span><i class="iconfont iconwenhao"></i>
          </div>
        </div>
      </div>
      <div class="job-description delivery" v-if="pageData.recruit_info.delivery_status && !live_token">
        <template >
          <p class="content-title flex-start">投递进度</p>
          <job-delivery-status :status="pageData.recruit_info.delivery_status" v-if="pageData.recruit_info.delivery_status"/>
        </template>
      </div>
      <div class="job-description">
        <template v-if="jobInformation.job_highlights && jobInformation.job_highlights.length">
          <p class="content-title flex-start">职位亮点</p>
          <div class="job-highlights">{{ jobInformation.job_highlights.join('、') }}</div>
        </template>

        <p class="content-title flex-start">职位描述</p>
        <div class="job-tags flex-start" v-if="jobInformation.job_tags && jobInformation.job_tags.length">
          <div class="job-tag-item flex-center" v-for="(item, index) in jobInformation.job_tags" :key="index">
            {{ item }}
          </div>
        </div>
        <div v-html="replaceHtml(jobInformation.jd)" class="description"></div>

        <div class="address-info" v-if="jobInformation.job_nature === '校招'">
          <p class="content-title flex-start">投递截止</p>
          <div class="job-highlights">{{ jobInformation.deadline }}</div>
        </div>

        <div class="address-info" v-if="jobInformation.address">
          <p class="content-title flex-start">工作地点</p>
          <span class="company-name">{{ jobInformation.address }}</span>
        </div>

      </div>
      <div class="company-box" v-if="companyShow">
        <p class="title">公司信息</p>
        <div class="company-detail flex-between" @click="toCompanyDetail" >
        <div class="info flex-start">
          <img :src="company_logo || companyInformation.logo_hr || companyInformation.logo" alt="">
          <div class="job-company">
            <p>{{ company_name || companyInformation.company_nick_name || companyInformation.company_full_name }}</p>

            <!-- boss有数据 -->
            <template v-if="boss_company">
              <div class="flex-start">
                <span v-if="boss_company.industry_name" class="flex-start">{{ boss_company.industry_name }}</span>
                <span v-if="boss_company.company_type"
                      class="flex-start">{{ boss_company.company_type }}</span>
                <span v-if="boss_company.company_scale" class="flex-start">{{ boss_company.company_scale }}</span>
              </div>
            </template>

            <!-- boss没有数据 -->
            <template v-else>
              <div class="flex-start">
                <span v-if="companyInformation.industry && companyInformation.industry.cls_cn_name" class="flex-start">{{ companyInformation.industry.cls_cn_name }}</span>
                <span v-if="companyInformation.company_type"
                      class="flex-start">{{ companyInformation.company_type }}</span>
                <span v-if="companyScale" class="flex-start">{{ companyScale }}</span>
              </div>
            </template>

          </div>
        </div>
        <span class="iconfont iconchevron-right"></span>
      </div>
      </div>
      <div class="jobscan-box" @click="handleClickJobscan">
        <div  class="jobscan-title-box">
          <p>匹配度分析</p>
          <div>{{!report ? '立即分析' : '查看报告'}}</div>
        </div>
        <div class="jobscan-content">
          本周内共 {{Number(jobInformation.id.toString().substr(4,2)) + 10}} 位应聘者投递了该职位，您的简历与该职位的匹配度为：<span class="score" v-if="!report">99分</span><span v-if="report" class="show-score">{{report.total_score}}分</span>
        </div>
        <div class="level-container">
          <img v-if="!!report" src="https://files.wondercv.com/pc/jobscan/Youarehere.png" alt="" width="66" height="25" :style="{transform: `translateX( calc( ( 100vw - 40px ) * ${toLoaction(report.total_score)} - 33px ) )`}">
          <div class="level-background">
            <div v-for="item in 4" class="level-item" :key="item">
            </div>
          </div>
          <div class="level-text-list">
            <div v-for="item in levelList" :key="item" class="level-item">
              {{item}}
            </div>
          </div>
        </div>
      </div>
      <div class="recommend-jobs" v-if="recommend.length">
        <p class="content-title flex-start like-title">猜你喜欢</p>
        <job-list :list-data="recommend" source="jobDetail"></job-list>
      </div>
      <div class="footer detail-footer flex-between" v-if="pageSource === 'invitation' && invitationInfo.status">
        <template v-if="invitationInfo.status === 'applied'">
          <div class="flex-center not-interested-btn" :class="['wxBtn', 'not_interested']" @click="changeRejectDialogState">不感兴趣</div>
          <div class="wxBtn flex-center" @click="handleOperation({ operation: 'passed' })">可以聊</div>
        </template>
        <button class="theme-button mailing-btn flex-center" @click="goToApp" v-else-if="invitationInfo.status === 'passed'">继续沟通</button>
        <div class="not_interested flex-center wxBtn" v-else-if="invitationInfo.status === 'rejected'" @click="handleOperation({ operation: 'applied' })">已表达不感兴趣，点击取消</div>
      </div>
      <div class="footer detail-footer flex-start" v-else-if="!wxCallback">
        <div class="footer-left flex-column-center" @click.stop="handleClickShare">
          <span class="iconfont iconfenxiang1"/>
          <span>分享</span>
        </div>
        <div class="footer-left flex-column-center" @click="changeLike(jobInfo)" :style="{color: jobInfo.is_like ? '#ff6644' : '#606060'}">
          <span class="iconfont" :class="jobInfo.is_like ? 'iconstar' : 'iconstar1'"/>
          <span>{{ jobInfo.is_like ? '已收藏' : '收藏' }}</span>
        </div>
        <button class="theme-button mailing-btn" @click="sendMailing" v-if="jobInfo.apply_url && jobInfo.apply_url.text === '投递已结束'">
          投递已结束
        </button>
        <template v-else>
          
          <!-- 直播投递 -->
          <template v-if="live_token">
            <!-- 直播未开始 -->
            <button v-if="!liveStartVisible" class="theme-button mailing-btn">直播开始后可投递</button>
            <!-- 直播已开始 -->
            <button v-else class="theme-button mailing-btn" @click="deliveryLiveJob()">
              {{ liveDelivryVisible ? '已投递': '立即投递' }}
            </button>
          </template>
          
          <!-- 普通投递 -->
          <button  v-else  class="theme-button mailing-btn" @click="sendMailingFun('origin')">
            {{jobInfo.apply_url && jobInfo.apply_url.text === '立即投递' ? '立即投递' : jobInfo.apply_url && jobInfo.apply_url.text === '已投递' && jobInformation.origin_source === 'jd' ? '继续沟通' : '已投递'}}
          </button>

        </template>
      </div>

      <div class="footer detail-footer flex-between" v-else>
        <div :class="['wxBtn', 'not_interested not-interested-btn', 'flex-center', !not_interested ? '' : 'only_not_intersted']" v-if="!isSendMail || not_interested" @click="notInterested">不感兴趣</div>
        <div class="wxBtn flex-center" v-if="!isSendMail && !not_interested" @click="wxSendMail">可以聊</div>
<!--        <div class="wxBtn flex-center" v-if="!isSendMail && !not_interested && isWechatBrowser">-->
<!--          <div class="chat-subscribe" v-if="!isSubscribe" @click="clickChat">可以聊</div>-->
<!--          <div class="chat-subscribe" data-growing-container v-else>-->
<!--            可以聊-->
<!--            <WechatOpenSubscribe :templateIds="templateIds" @handleClick="wxSendMail">-->
<!--              <template slot="subscribe-slot">-->
<!--                <script type="text/wxtag-template">-->
<!--                  <style>-->
<!--                    .btn2 {-->
<!--                      width: 100%;-->
<!--                      height: 100px;-->
<!--                    }-->
<!--                  </style>-->
<!--                  <div class="btn2">可以聊</div>-->
<!--                </script>-->
<!--              </template>-->
<!--            </WechatOpenSubscribe>-->
<!--          </div>-->
<!--        </div>-->
        <button class="theme-button mailing-btn flex-center" @click="goToApp" v-if="isSendMail && !not_interested">
          继续沟通
        </button>
      </div>

      <job-alert :state="jobAlertShow" :page-data="pageData" @handleClose="jobAlertShow = false"/>
      <job-alert :state="jobJobAlertShow" :page-data="{modal_text:{button: '导入简历',content:'请先创建简历，或导入已有简历，即可分析',title:'上传简历立即分析'}}" @handleClose="jobJobAlertShow = false"/>
      <job-mailing :liveToken="live_token" :state="mailingShow" :cv-data="cvList" :online-check-state="onlineCheckState"
                   :cv-account-token="cvAccountToken" @handleClose="mailingShow = false" @sendMailing="mailing"/>
      <job-scan :state="jobscanShow" :cv-data="cvList.filter(item=> item.lang === '中')" :online-check-state="onlineCheckState"
                :cv-account-token="cvAccountToken" @handleClose="jobscanShow = false" @sendTest="sendTest"/>
      <job-send-success :post-list="recommend" :source="jobInformation.source" :state="successState"
                        @handleClose="closeDelivery" :cvs="pageData.cvs" :cv-index="cvIndex" :isSubscribe="isSubscribe" :templateIds="templateIds"
                        @on-toast="handleClickOneKeySucceed" />
      <w-loading v-show="loadingShow" :show-text="true"/>
    </div>
    <page-loading v-else/>
    <w-toast v-show="toastShow" :toast-data="toastData"/>
    <reject-dialog :dialog-show="rejectDialogState" @handleClose="changeRejectDialogState" :rejectSure="(text) => handleOperation({ reason: text, operation: 'rejected' })"></reject-dialog>
<!--    <w-dialog :dialogShow="subscribeState" @handleClose="" :top="23">-->
<!--      <template slot="content">-->
<!--        <div class="subscribe-guidance-container" v-if="subscribeState">-->
<!--          <div class="main">-->
<!--            <span class="title">通知提醒</span>-->
<!--            <span class="desc">点击【允许】按钮可及时收到HR反馈哦</span>-->
<!--            <div class="guide">-->
<!--              <img src="https://files.wondercv.com/m/subscribe/subscribe-gif.gif" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="subscribe-footer" data-growing-container>-->
<!--            我知道了-->
<!--            <WechatOpenSubscribe :templateIds="templateIds" @handleClick="subscribeClick">-->
<!--              <template slot="subscribe-slot">-->
<!--                <script type="text/wxtag-template">-->
<!--                  <style>-->
<!--                    .btn2 {-->
<!--                      width: 100%;-->
<!--                      height: 100px;-->
<!--                    }-->
<!--                  </style>-->
<!--                  <div class="btn2">我知道了</div>-->
<!--                </script>-->
<!--              </template>-->
<!--            </WechatOpenSubscribe>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
<!--    </w-dialog>-->
    <!--    <more-jobs-mailing :state="moreJobsState"></more-jobs-mailing>-->
    <job-share slot="content" :hr="hr" :job="jobInformation" :company="companyInformation" v-if="shareCard" @close="shareCard = false"/>
  </div>
</template>

<script>
  import moment from "moment"
	import WDialog from '../../components/global/w-dialog'
	import WSelect from '../../components/global/w-select'
  import WLoading from '../../components/global/w-loading'
	import WNavBar from '../../components/global/w-navbar'
	import jobAlert from '../job-components/job-alert'
  import jobMailing from '../job-components/job-mailing'
  import jobScan from '../job-components/job-jobscan'
	import jobSendSuccess from '../job-components/job-send-success'
	import jobList from '../job-components/job-list'
	import WToast from '../../components/global/w-toast'
  import OpenApp from '../../components/cv/open-app'
	import moreJobsMailing from '../job-components/more-jobs-mailing'
  import WechatOpenSubscribe from '../../components/wechat-open-subscribe/wechat-open-subscribe'
  import RejectDialog from '../cv-inbox/RejectDialog'
	import { componentsMixin } from '../../assets/js/mixin/components'
	import { envMixin, loginMixin, downloadAPPMixin } from '../../assets/js/mixin/global'
  import { ioMixin } from '../../assets/js/mixin/io'
	import { jobsMixin } from '../../assets/js/mixin/jobs'
	import { userMixin } from '../../assets/js/mixin/user'
	import { scale_options } from '../../assets/json/company'
  import WPopup from "../../components/global/w-popup"
  import JobDeliveryStatus from "./job-delivery-status.vue";
  let wx = require('weixin-js-sdk')
  import api from "../../api/api-list/jobs"
  import {toHTML, cutImage} from "./toHtml";
  import JobShare from "./job-share";
	import { mapState, mapMutations, mapActions } from 'vuex'

  export default {
		name: 'job-detail',
		mixins: [ componentsMixin, loginMixin, envMixin, jobsMixin, userMixin, downloadAPPMixin, ioMixin ],
		data () {
			return {
        moment,
				notJob: false,
				recommend: [],
				toastData: {},
				toastShow: false,
				jobInformation: {},
				companyInformation: {},
				moreJobsState: true,
				successState: false,//投递成功后显示一键投递
        wxCallback: false,  // 是否是微信召回
        isSendMail: false,
        not_interested: false,  // 是否点击了不感兴趣
        cvs_token: '',     // 邀约召回时候的简历token
        needShare: false,
				invitationInfo: {}, // 邀约的信息
				rejectDialogState: false, //拒绝邀约弹窗
        levelList:['较低', '一般', '较为匹配', '非常匹配'],
        jobscanShow:false,
        report: null,
        jobJobAlertShow: false,//jobscan没有简历创建简历
        hr:{},
        isJobMiniProgram: false,   // 是否是名企直投小程序
        subscribeState: false,  // 引导订阅弹窗开关
        templateIds: (process.env.VUE_APP_ENV === 'local' || process.env.VUE_APP_ENV === 'staging') ?
          ['e4deJRUv1skWugHLSejKYiS1u29H8_NzzFfHMZmCqls', 'PkS3S9vbyoN5tsBOE9bSOT-eRch17ndO6yam4eG8TdU', '7pjAgcuZ7Qr6g1_6VCQE5p3flLLRLDvJimDrdiO1jA8'] :
          ['jPKlv_vNTacSAtTTqe7oKKiMfdxcDu3Lq92PJMiRimU', 'cNP7tixFPNfl5RjubzXO39Kah_mGzpzeji8JfsbLj0o', 'xEOMT0rZgWCgLgMq_lceRaoQK57ZdwOt6txNOKLOYgs'],      // 模板 ID 集合
        isSubscribe: false,   // 订阅弹窗是否出现过（每个设备只出现一次）
        shareCard: false,

        job_token: null, // 职位 token
        live_token: null, // 直播 token
        liveDetail: {},
        liveDelivryArr: [],
        liveDelivryVisible: false, // 是否投递过该直播职位
        liveStartVisible: false, // 是否到达预计开播时间
        liveStartDifference: 0, // 开始倒计时时间（秒）
        liveTimer: null // 直播定时器

			}
		},
		async beforeRouteUpdate (to, from, next) {
			this.loading = true
			await this.getPageData(to.params.token, to.query.companyToken)
			window.scrollTo(0, 0)
			next()
		},
    async created() {
      let { token } = this.$route.params
      this.job_token = token
      let { live_token } = this.$route.query
      // 有直播 token 说明来自直播详情页跳转（目前），投递是直播投递
      if (live_token) {
        // 直播 token
        this.live_token = live_token
        // 获取直播数据
        await this.getLiveDetail()
        // 初始化 直播倒计时
        this.initLiveDelivery()
      }

		  let origin = this.$route.query.in
      if (origin && origin === 'job_xcx') {
        this.isJobMiniProgram = true
      }
    },
    async mounted () {
		  this.getBriefReport()
			this.initWxCallback()
			this.changeNeedShareValue()
			await this.loginByWeChat()
			// 各种小程序根据jwt&&jwt_timestamp 自动登录
			await this.miniprogramAutoLogin();
			await this.getPageData()
			this.path = this.$route.path
			this.verifyLogged()
			if (!this.alreadyLogged) {
				this.pageData.recruit_info = {
					apply_url: {
						text: '立即投递'
					}
				}
			}
      let isSubscribe = this.$db.ls.get("isSubscribe")
      if (isSubscribe) {
        this.isSubscribe = true
      }
		},
    destroyed () {
      clearInterval(this.liveTimer)
    },
		computed: {
      ...mapState('live', ['liveDelivryList']),
			companyToken () {
				let token = this.$route.query.companyToken
				if (this.jobInformation.company_token) {
					return this.jobInformation.company_token
				} else if (token && token !== 'null' && token !== 'undefined') {
					return token
				}
			},
      boss_company () {
        return this.jobInformation.boss_company
      },
      boss_hr () {
        return this.jobInformation.boss_hr
      },
      company_name () {
        if (this.boss_company) {
          return this.boss_company.company_name
        }
        return ''
      },
      company_logo () {
        if ( this.boss_company ) {
          return this.boss_company.company_logo
        }
        return ''
      },
			jobInfo () {
				return this.pageData.recruit_info
			},
			// 公司规模
			companyScale () {
				for (let i = 0; i < scale_options.length; i++) {
					if (this.companyInformation.size_max <= scale_options[i].max) return scale_options[i].label
				}
			},
			//是否显示公司相关信息
			companyShow () {
				let compInfo = Object.keys(this.companyInformation)
				return compInfo.length && this.companyToken
			},
      pageSource() {
				return this.$route.query.pageSource
      }
		},
		watch: {
      liveDelivryList: {
        handler (newV) {
          if (newV && newV.length) {
            this.liveDelivryVisible = newV.includes(this.job_token)
          }
        },
        deep: true
      }
    },
		components: {
      JobShare,
			WDialog,
			WSelect,
			WLoading,
			WNavBar,
			jobAlert,
			jobMailing,
			pageLoading: WLoading,
			WToast,
			moreJobsMailing,
			jobList,
			jobSendSuccess,
      OpenApp,
      RejectDialog,
      jobScan,
      WechatOpenSubscribe,
      WPopup,
      JobDeliveryStatus
		},
		methods: {
      ...mapMutations('live', [ 'setLiveDetailData', 'setLiveDelivryList' ]),

      // 直播投递
      deliveryLiveJob () {
        // 投递过该直播职位
        if (this.liveDelivryVisible) return false
        // 直播职位用户投递是否超过上线
        if (this.liveDelivryArr.length >= this.liveDetail.max_delivery_count) {
          this.showToast('可投递职位数已达上限')
          return false
        }
        this.sendMailingFun()
      },
      sendMailingFun (source) {

        // 判断是不是boss数据
        if (this.jobInformation.origin_source === "boss直聘") {

          this.handleToMiniProgram(this.jobInformation.m_target)

        } else {

          // 如果不是boss的数据 继续走之前的老逻辑
          if (source === 'origin') {
            if (this.jobInfo.apply_url && this.jobInfo.apply_url.text === '立即投递') {
              if (!this.pageData.cvs.length) {
                this.$createDialog({
                  title: '暂无简历',
                  type: 'confirm',
                  content: '创建简历后可投递职位?',
                  confirmBtn: {
                    text: '创建简历',
                  },
                  cancelBtn: {
                    text: '取消',
                  },
                  onConfirm: () => {
                    this.$router.replace(`/cvs`)
                  }
                }).show()
              } else {
                this.sendMailing()
              }
            } else {
              this.sendMailing()
            }
          } else {
            if (!this.pageData.cvs.length) {
              this.$createDialog({
                title: '暂无简历',
                type: 'confirm',
                content: '创建简历后可投递职位?',
                confirmBtn: {
                  text: '创建简历',
                },
                cancelBtn: {
                  text: '取消',
                },
                onConfirm: () => {
                  this.$router.replace(`/cvs`)
                }
              }).show()
            } else {
              this.sendMailing()
            }
          }

        }

      

      },
      // 初始化 直播职位
      initLiveDelivery () {
        // 没有直播token 说明是普通投递
        if (!this.live_token) return false
        // 投递已结束 公用
        // 未投递 分开（hr和邮箱）
        // 已投递 分开（hr和邮箱）

        let liveStartTime = this.liveDetail.start_at
        // 当前时间戳
        let nowTime = this.moment().unix()
        // 直播开始时间戳
        let startTime = this.moment(liveStartTime).unix()
        let targetTime = nowTime - startTime
        // 直播已开启
        if (targetTime > 0) {
          this.liveStartVisible = true
        // 直播还未开启
        } else {
          this.liveStartVisible = false
          // 
          this.liveStartDifference = Math.abs(targetTime)
          // 开启倒计时
          this.liveTimer = setInterval(() => {
            if (this.liveStartDifference === 0) {
              clearInterval(this.liveTimer)
              this.liveStartVisible = true
            } else {
              this.liveStartDifference -= 1
            }
          }, 1000)
        }
      },
      // 获取直播详情数据
      async getLiveDetail () {
        try {

          // 获取直播详情数据
          let liveDetailRes = await this.$api.live.getLiveDetail(this.live_token)
          if(liveDetailRes.code === 1000){
            this.liveDetail = liveDetailRes.data
            this.setLiveDetailData(this.liveDetail)
          }

          // 获取用户投递过的直播职位列表 并判断用户是否投递过该直播职位
          let liveDelivryRes = await this.$api.live.getLiveDelivryList(this.live_token)
          if (liveDelivryRes.code === 1000) {
            this.liveDelivryArr = liveDelivryRes.data.jobs
            this.liveDelivryVisible = this.liveDelivryArr.includes(this.job_token)
            this.setLiveDelivryList(this.liveDelivryArr)
          }

        } catch (e) {
          console.log(e)
        }
      },
		  // 点击了 可以聊
		  clickChat() {
        this.subscribeState = true
      },
		  // 自定义订阅组件点击事件
      subscribeClick() {
        this.subscribeState = false
        this.wxCallback && this.wxSendMail()
        this.$db.ls.set('isSubscribe', true)
        this.isSubscribe = true
      },
			// 微信授权登录
      async loginByWeChat() {
	      let code = this.$route.query.code
        await this.loginByWx()
        this.$db.ls.remove('wxCallback')
        this.$db.ls.remove('cvsToken')
        if (this.$db.ls.get('pageSource') === 'invitation') {
          this.$db.ls.remove('pageSource')
          await this.$router.replace({
            path: window.location.pathname,
            query: {
              pageSource: 'invitation'
            }
          })
        }
      },
			// 简历下载召回参数存储问题
      initWxCallback() {
      	if (this.$db.ls.get('wxCallback')) {
		      this.wxCallback = !!this.$db.ls.get('wxCallback');
		      this.cvs_token = this.$db.ls.get('cvsToken')
        } else {
		      this.wxCallback = !!this.$route.query.callback;
		      this.cvs_token = this.$route.query.cvsToken
        }
      },
			// 改变拒绝弹窗的状态
      changeRejectDialogState() {
        let logged = !!this.alreadyLogged
        if (logged) {
          this.rejectDialogState = !this.rejectDialogState
        } else {
          this.$db.ls.set('pageSource', 'invitation')
          this.needLogin()
        }
      },
		  // 打开APP
      openLinkApp(needReload) {
        let link = {
          ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=other&token=${this.$route.params.token}&companyToken=${this.$route.query.companyToken}&open_type=jobDetail`,
          android: `android://h5/open?token=${this.$route.params.token}&type=jobDetail&companyToken=${this.$route.query.companyToken}`,
        }
        this.openApp(link, needReload)
      },
		  // 关闭一键投递弹窗的回调
      closeDelivery(params) {
        this.successState = false
        if (!params) {
          // if (this.isWechatBrowser) {
          //   // 没有显示过订阅引导弹窗显示订阅引导弹窗
          //   if (!this.isSubscribe) this.subscribeState = true
          //   this.$db.ls.set('isSubscribe', true)
          // }
          // this.$db.ls.set('shareNeed', true)
          setTimeout(() => {
            this.$db.ls.set('shareNeed', true)
            this.$router.push({ path: '/welcome/to_app', query: { type: 'person' } })
          }, 1000)
        }
      },
		  // 点击了可以聊投递简历
      async wxSendMail() {
      	let logged = !!this.alreadyLogged
        const fn = async () => {
          if (this.cvs_token) {
            try {
              await this._selectCvMailing(this.cvs_token, "", 'wechatInvite')
              this.isSendMail = !this.isSendMail
            } catch (e) {
              console.error(e)
            }
          } else {
            this.showToast('简历丢失，请检查重试')
          }
        }
        if (logged) {
        	fn()
        } else {
        	this.$db.ls.set('wxCallback', this.wxCallback)
        	this.$db.ls.set('cvsToken', this.cvs_token)
        	this.needLogin()
        }
        // this.verifyLogin(this.logged, fn, window.location.href)
      },
		  // 点击了不感兴趣按钮
      notInterested() {
        let logged = !!this.alreadyLogged
        if (logged) {
	        this.not_interested = true;
	        this.showToast('已标记不感兴趣',1500)
        } else {
	        this.$db.ls.set('wxCallback', this.wxCallback)
	        this.$db.ls.set('cvsToken', this.cvs_token)
        	this.needLogin()
        }
      },
		  // 跳转APP引导下载页
		  goToApp() {
        this.$router.push({ path: '/welcome/to_app', query: { type: 'person' } })
      },
      // 页面返回事件
			toBack () {
      	if (this.isWxMini) {
      		this.$wechat.miniProgram.reLaunch({
			      url: `/pages/job-list/job-list?url=${ process.env.VUE_APP_HOST }/jobs/recommend`
          })
        } else if (window.history.length > 1) {
      		this.$router.back()
        } else {
      		window.location.href = '/jobs'
        }
			},
			// 跳转公司详情页
			toCompanyDetail () {

        // 判断是不是boss来源数据
        if (this.jobInformation.origin_source === "boss直聘") {

          this.handleToMiniProgram(this.boss_company.m_company_website_url)
    
        } else {

          // 不是boss数据走老逻辑
          let token = this.companyToken || this.jobInformation.company_token
          if (token) {
            window.location.href = `/company/${ token }.html?isJobMiniProgram=${this.isJobMiniProgram}`
            this.$db.ls.set('shareNeed', true)
          }

        }
			},
      //点击hr块
      handleClickTohr(){
        if(this.isWxMini){
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/blog-detail/blog-detail?url=https://mp.weixin.qq.com/s/uOdTXoAnMa9Q7rPtHMUu7g`
          })
        } else {
          this.$router.push({ path: '/welcome/to_app', query: { type: 'person' } })
        }
      },
      // 跳转boss逻辑

      handleToMiniProgram (miniProgramUrl) {
        // 判断当前是不是微信小程序
        if (this.isWxMini) {
          console.log('小程序环境')
          let url = encodeURIComponent(miniProgramUrl)
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/jump-page/jump-page?url=${url}`,
          })
        } else {
          window.location.href = 'https://m.zhipin.com/sem/7-nrjr.html?sid=market_azjrcm_WonderCV'
        }
      },
			// 获取详情和推荐职位数据
			async getPageData (jobToken, compToken) {
				let token = jobToken || this.$route.params.token
				let companyToken = compToken || this.$route.query.companyToken
        let payload = this.pageSource === 'invitation' ? { has_application: 1 } : {}
				let jobData = this.$api.HrApi.getRecommendJobDetail(token, payload)
				let pageData = this.$api.jobs.getJobInfo(token)
				let companyData = companyToken ? this.$api.staticApi.getCompanyDetail(companyToken) : new Promise((resolve) => resolve({}))
				const [ cvData, jobInfo, compInfo ] = await Promise.all([ pageData, jobData, companyData ])
				if (cvData.code === 1000) this.pageData = cvData.data
				if (jobInfo.code === 1000) {
					this.jobInformation = jobInfo.data.job
          this.invitationInfo = jobInfo.data.application || {}
          this.hr = jobInfo.data.hr_info || {}
				} else if (jobInfo.code === 80135) {
					this.notJob = true
        }
        let companyInfo = {}
				if ((!companyToken || companyToken === 'null' || companyToken === 'undefined') && this.jobInformation.company_token) {
					companyInfo = await this.$api.staticApi.getCompanyDetail(this.jobInformation.company_token)
          if (companyInfo.code === 1000) this.companyInformation = companyInfo.data
				} else if (compInfo.code === 1000) {
					this.companyInformation = compInfo.data
        }
        this.$route.meta.shareByWx('超级简历直达Offer，快人一步拿高薪！',
                                    { title: `内推 - ${ this.companyInformation.company_nick_name } - ${ this.jobInformation.job_post }`,
                                      imgUrl: this.companyInformation.logo })
				// if (jobInfo.code === 1000 && (compInfo.code === 1000 || companyInfo.code === 1000)) {
        let data = {
          // 'from': 0,
          // size: 5,
          // company_industry: this.companyInformation.industry.cn,
          // city_names: this.jobInformation.city,
          // profession_id: this.jobInformation.profession_id,
          // job_nature: this.jobInformation.job_nature,
          // exclude_token: token
          size: 5,
          page: 1,
          job_token: token,
        }
        // let res = await this.$api.HrApi.getJobToJob()
        let res = await this.$api.recommend.jobToJob(data)
        if (res.code === 1000) this.recommend = res.data.jobs
				// }
				this.loading = false
			},
			// 存储点击职位title
			viewJobDetail (item) {
				this.$db.ss.set('jobName', item.job_title)
			},
			//一键投递成功
			handleClickOneKeySucceed (data) {
				this.toastData = data
				this.toastShow = true
				setTimeout(() => {
					this.toastShow = false
				}, 1000)
			},
      // 处理操作按钮的逻辑
      async handleOperation(payload) {
        let logged = !!this.alreadyLogged
        const fn = async () => {
          let { id } = this.invitationInfo
          try {
            let res = await this.$api.inbox.applyOperate(id, payload)
            if (res.code === 1000) {
              if (payload.operation === 'passed') {
                this.showToast('已同意申请')
              } else if (payload.operation === 'rejected') {
                this.showToast('已拒绝申请')
              } else if (payload.operation === 'applied') {
                this.showToast('已取消不感兴趣')
              }
              this.reportedData({
                data_type: 'job_invite',
                data: {
                  permission_ids: [ id ],
                  operation: payload.operation
                }
              })
              this.invitationInfo.status = payload.operation
              this.rejectDialogState = false
            }
          } catch (e) {
            console.log(e)
          }
        }
        if (logged) {
          fn()
        } else {
          this.$db.ls.set('pageSource', 'invitation')
          this.needLogin()
        }
      },
      handleClickJobscan(){
        this.verifyLogin(this.logged, async () => {
          if(this.report){
            window.location.href=`/jobscan/results/${this.report.token}.html?isJobMiniProgram=${this.isJobMiniProgram}`
          }else{
              if(this.cvList.filter(item=>item.lang === '中').length === 1 ){
                this.sendTest(this.cvList[0].token)
              }else if(this.cvList.filter(item=>item.lang === '中').length === 0) {
                this.showToast('无合适中文简历')
                setTimeout(()=>{
                  this.jobAlertShow = true
                },1000)
              }else {
                this.jobscanShow = true
              }
          }
        }, this.path)
      },
      //获取测试报告
      async getBriefReport(){
          try {
            let res = await this.$api.jobs.getBriefReport({job_token: this.$route.params.token, cache:"yes"})
            if(res.code === 1000){
               this.report = res.data
            }
          }catch (e) {
            console.log(e)
          }
      },
      async sendTest(token){
        try{
          this.loadingShow = true
          this.jobscanShow = false
          let cv_token = token
          let job_token = this.$route.params.token
          let job_has_been_modified = false
          let job_post = this.jobInformation.job_post
          let company_name = this.jobInformation.company_nick_name || this.jobInformation.company_full_name
          let job_description = this.jobInformation.jd
          let cache = 'yes'
          let res = await this.$api.jobs.createReport({cv_token, job_token, job_has_been_modified, job_post, company_name, job_description, cache})
          this.loadingShow = false
          if(res.code === 1000){
            let { token } = res.data
            window.location.href=`/jobscan/results/${token}.html`
          }else if(res.code === 200104){
            this.$createDialog({
              type: 'confirm',
              title: '温馨提示',
              content: `简历内容较少,
              请完善到 60 分以上再进行分析`,
              confirmBtn: {
                active: true,
                color:"#E95E55",
                text: '完善简历'
              },
              cancelBtn: {
                active: false,
                text: '取消'
              },
              onConfirm: () => {
                this.$router.replace('/cvs');
              }
            }).show()
          }else {
            this.showToast(res.message)
          }

        }catch (e) {
          this.loadingShow = false
        }


      },
      toLoaction(score = 0){
        if(score >=0 && score < 30){
          return 0.125
        }else if(score >=30 && score < 60){
          return 0.375
        }else if(score >=60 && score < 80){
          return 0.625
        }else if(score >=80 && score <= 100){
          return 0.875
        }
      },
      //点击职位分享
      handleClickShare(){
		    this.shareCard = true
      }
		},
		filters: {
			degreeFilter (val) {
				if (!val) {
					return '学历不限'
				} else if (val.includes('不限')) {
					return '学历不限'
				} else {
					return val
				}
			},
			experienceFilter (val) {
				if (!val) {
					return '经验不限'
				} else if (val.includes('不限')) {
					return '经验不限'
				} else {
					return val
				}
			},
      formatGraduationYear (yearArr) {
        if (!yearArr || !yearArr.length) return ''
        let newArr = yearArr.map(item => {
          return String(item).substring(2)
        })
        return newArr.join('/') + '届'
      }
		}
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  @import "@/assets/scss/global/mixin";
  .subscribe-guidance-container {
    width: 335px;
    //min-height: 412px;
    background-color: #fff;
    border-radius: 12px;
    .main {
      width: 100%;
      padding: 24px 45px 19px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 1px solid #f4f4f4;
      .desc {
        margin-top: 12px;
      }
      .guide {
        width: 235px;
        height: 240px;
        margin-top: 22px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      span {
        color: #404040;
      }
    }
    .subscribe-footer {
      width: 100%;
      height: 52px;
      position: relative;
      text-align: center;
      line-height: 52px;
      color: #E95E55;
    }
  }
  .job-detail-container {
    overflow: hidden;
    .mobile-nav {
      .right-content {
        .iconfont {
          font-size: $font-size-large;
          color: $color-theme;
          font-weight: bold;
        }
      }
    }
    .navbar {
      position: fixed;
      left: 0;
      top: 56px;
    }
  }
  .detail-wrapper {
    @include mobile-container(94px, 64px);
    background-color: #F8F8FA;
    .job-top {
      padding: 0 20px;
      background-color: $color-light;
      margin-bottom: 6px;

      .detail-header {
        width: 100%;
        padding: 25px 0;
        border-bottom: 1px solid #f9f9f9;

        .job-post {
          margin-bottom: 13px;
          align-items: flex-start;

          .job-title {
            font-size: $font-size-large;
            color: $color-title;
            line-height: 24px;
            font-weight: 600;
            margin-right: 10px;
            word-break: break-all;
          }
          .hr-talk {
            display: inline;
            width: 36px;
            height: 20px;
            vertical-align: middle;
            //margin-left: 3px;
          }
          .job-salary {
            white-space: nowrap;
            color: $color-theme;
            font-size: $font-size-medium-x;
            line-height: 24px;
            font-weight: 600;
          }
        }

        .job-basic-info {
          font-size: $font-size-medium;
          /*margin-bottom: 14px;*/
          margin-left: -2px;

          .iconfont{
            font-size: 16px;
            color: #606060;
            margin-right: 4px;
          }

          div {
            display: flex;
            align-items: center;
            font-size: 0;
            margin-right: 21px;

            &:last-child {
              margin-right: 0;
            }

            >span {
              color: #606060;
              font-weight: 400;
              font-size: 14px;
              line-height: 1;
            }

          }

        }

        .job-source {
          font-size: 12px;
          color: #9C9C9C;
          font-weight: 400;
          margin-top: 16px;
        }
      }
      .hr-box{
        border-top: 1px solid #F9F9F9;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        .hr-info{
          display: flex;
          // margin-bottom: 8px;
          .flex{
            display: flex;
            align-items: center;
          }
          & > img{
            margin-right: 12px;
            border-radius: 50%;
          }
          .hr-name{
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            margin-right: 10px;
          }
          .hr-dot{
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #45d694;
            margin-right: 4px;
          }
          .hr-state{
            font-size: 12px;
            font-weight: 400;
            color: #BCBCBC;
            line-height: 17px;
          }
          .company-name{
            font-size: 14px;
            font-weight: 400;
            color: #606060;
            letter-spacing: 1px;
          }
        }
        .interview{
          padding: 12px 16px;
          background-color: #F5F8FF;
          display: flex;
          justify-content: space-between;
          border-radius: 5px;
          position: relative;
          font-size: 14px;
          font-weight: 400;
          color: #404040;
          line-height: 20px;
          .iconfont{
            font-size: 16px;
            color: #9C9C9C;
          }
          &::after{
            content: "";
            position: absolute;
          }
        }
      }

    }
    .company-box{
      padding: 30px 20px 0;
      background-color: $color-light;
      margin-bottom: 6px;
      .title{
        font-size: 18px;
        font-weight: 500;
        color: #262A30;
        line-height: 25px;
      }
      .company-detail {
        background-color: $color-light;
        padding: 20px 0;

        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          border: 1px solid #f9f9f9;
          border-radius: 5px;
          margin-right: 12px;
        }

        .job-company {
          color: $color-light-gray;

          p {
            margin-bottom: 10px;
            line-height: 16px;
            font-size: $font-size-medium-x;
            color: $color-title;
            @include ellipsis(240px);
          }

          span {
            display: inline-block;
            line-height: 18px;
            color: #9C9C9C;
            font-weight: 300;
            @include ellipsis(85px);

            &::before {
              content: '';
              display: inline-block;
              width: 1px;
              height: 12px;
              background-color: #9c9c9c;
              margin: 0 6px -1px;
            }

            &:first-child::before {
              display: none;
            }
          }
        }

        .iconchevron-right {
          color: $color-title;
        }
      }
    }
    .job-description {
      padding: 24px 20px;
      margin-bottom: 6px;
      background-color: $color-light;

      .job-highlights {
        line-height: 26px;
        font-size: 14px;
        color: #606060;
        margin-bottom: 30px;
      }

      .job-tags {
        margin-bottom: 6px;
        flex-wrap: wrap;

        .job-tag-item {
          font-size: 12px;
          height: 25px;
          line-height: 25px;
          padding: 0 12px;
          border-radius: 2px;
          background-color: #F9F9F9;
          color: #606060;
          margin-right: 10px;
          white-space: nowrap;
          margin-bottom: 10px;
        }
      }

      .description {
        color: $color-dark-gray;
        font-size: $font-size-medium;
        line-height: 26px;
        word-break: break-all;

        /deep/ * {
          word-break: break-all;
          font-size: $font-size-medium;
        }

        /deep/ p {
          /*min-height: 32px;*/
        }
      }

      .address-info {
        margin-top: 40px;

        .company-name {
          color: $color-dark-gray;
          line-height: 26px;
        }
      }
    }
    .job-description.delivery {
      padding-bottom: 10px;
    }
    .recommend-jobs {
      padding: 24px 0 16px 0;
      background-color: $color-light;
      /deep/ .recommend-item {
        border-bottom: 1px solid #f9f9f9;
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .detail-footer {
      width: 100vw;
      padding: 0 24px;
      @include ipx-footer(65px, 1px);
      background-color: $color-light;
      box-shadow: 0 -1px 1px 0 rgba(194, 194, 194, 0.5);
      .wxBtn {
        flex: 1;
        height: 42px;
        border-radius: 21px;
        background-color: #ff6644;
        color: #fff;
        font-size: 14px;
        border: 1px solid #ff6644;
        overflow: hidden;
        position: relative;
        .chat-subscribe {
          width: 100%;
          height: 100%;
          position: relative;
          text-align: center;
          line-height: 42px;
        }
      }
      .not_interested {
        background-color: #fff;
        border-color: #ececec;
        color: #9c9c9c;
      }
      .not-interested-btn {
        margin-right: 16px;
      }
      .footer-left {
        margin-right: 24px;
        color: $color-dark-gray;
        min-width: 24px;
        span {
          font-size: $font-size-small;
          font-weight: 400;
        }
        .iconfont {
          font-weight: bold;
          font-size: 18px;
          margin-bottom: 6px;
        }
      }
      button {
        flex: 1;
        height: 45px;
        font-size: $font-size-medium-x;
        border-radius: 22px;
        color: #ffffff;
        background-color: #FF6644;
        &:disabled {
          background-color: #cccccc;
        }
      }
    }
    .content-title {
      font-size: $font-size-large;
      color: $color-title;
      font-weight: 500;
      white-space: nowrap;
      margin-bottom: 24px;
      // padding: 0 16px;
      // &::after {
      //   display: inline-block;
      //   content: '';
      //   background-color: #EEF0F5;
      //   width: 65vw;
      //   height: 1px;
      //   margin-left: 15px;
      // }
    }
    .content-title.like-title{
      margin-left: 16px;
    }
    .like-title {
      margin-bottom: 0;
    }
    .jobscan-box{
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      border-bottom: 6px solid #f9f9f9;
      .jobscan-title-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 7px;
        p{
          font-size: 18px;
          font-weight: 500;
          color: #262A30;
          line-height: 25px;
        }
        div{
          width: 76px;
          height: 24px;
          border-radius: 12px;
          border: 1px solid #FF8569;
          color: #FF6644;
          text-align: center;
          line-height: 22px;
        }
      }
      .jobscan-content{
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 26px;
        position: relative;
        .score{
          color: #ff6644;
          filter: blur(2px);
        }
        .show-score{
          color: #ff6644;
        }
      }
      .level-container{
        padding-top: 19px;
        img{
          margin-bottom: 10px;
        }
        .level-background{
          width: 100%;
          height: 7px;
          background: linear-gradient(90deg, #FF6644 0%, #FFC346 100%);
          border-radius: 4px;
          display: flex;
          margin-bottom: 5px;
          .level-item{
            flex: 1;
            border-right: 1px solid #fff;
            box-sizing: border-box;
            &:last-child{
              border-right: 0px;
            }
          }
        }
        .level-text-list{
          width: 100%;
          display: flex;
          .level-item{
            flex: 1;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #BCBCBC;
            line-height: 17px;
          }
        }
      }
    }
  }
  .not-job {
    height: 100vh;
    background-color: $color-light;
    overflow: hidden;
    img {
      width: 100vw;
    }
  }
</style>
